import React from "react";
import PropTypes from 'prop-types';


const propTypes = {
    item: PropTypes.object,
};


export default class MenuItem extends React.Component {
    constructor(props){
        super(props);
    }



    render() {

        const {item} = this.props;
        const {itemRoute, itemLabel} = item;

        return(
            <a href={itemRoute} className='menu--items'>{itemLabel}</a>
        );
    }
}

MenuItem.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/DropdownMenu/MenuItem.js